export function getRDG(userDoc: string): number | string | null {
  const userRdg = !!userDoc ? Number(userDoc.slice(6,9).replace('.', '')) : '';
  return userRdg;

}
